import { Box } from "@mui/material";

interface Props {
  onAnimationEnd: () => void;
}

export const CompletionOverlay = ({ onAnimationEnd }: Props) => (
  <Box
    component="span"
    onAnimationEnd={onAnimationEnd}
    sx={{
      position: "absolute",
      inset: 0,
      bgcolor: "action.hover",
      transformOrigin: "left",
      zIndex: 0,
      "@keyframes fillLTR": {
        from: { transform: "scaleX(0)" },
        to: { transform: "scaleX(1)" },
      },
      animation: "fillLTR 2s ease forwards",
    }}
  />
);
